import { ReactElement } from 'react';
import { useIntl } from 'react-intl';

import {
  FacebookIcon,
  FacebookShareButton,
  PinterestIcon,
  PinterestShareButton,
  WhatsappIcon,
  WhatsappShareButton,
} from 'react-share';

import * as S from './styles';

interface Props {
  productImage?: string;
  productUrl: string;
}

const shareButtonsCommonProps = {
  // buttonProps: { className: 'share-project__share-button' },
  iconProps: {
    // className: 'share-project__share-icon',
    path: '', // NOTE: required type
    round: true, // Whether to show round or rect icons (bool)
    size: 46, // Icon size in pixels (number)
    // borderRadius: Allow rounded corners if using rect icons (number)
    // bgStyle: customize background style, e.g. fill (object)
    // iconFillColor: customize icon fill color (string, default = 'white')
  },
};

export function ShareIcons({ productImage, productUrl }: Props): ReactElement {
  const intl = useIntl();
  return (
    <S.ShareIconsWrapper>
      <FacebookShareButton
        url={productUrl}
        quote={intl.formatMessage({
          defaultMessage: 'RENO doors - sliding doors with unforgetable style',
          id: 'T4MmA0',
        })} // (string): A quote to be shared along with the link.
        hashtag={intl.formatMessage({
          defaultMessage: '#renodoors',
          id: 'SroRrm',
        })} // hashtag (string): A hashtag specified by the developer to be added to the shared content. People will still have the opportunity to remove this hashtag in the dialog. The hashtag should include the hash symbol.
      >
        <FacebookIcon {...shareButtonsCommonProps.iconProps} />
      </FacebookShareButton>
      <WhatsappShareButton
        url={productUrl}
        title={intl.formatMessage({
          defaultMessage: 'RENO doors',
          id: 'q6VJYI',
        })} // (string): Title of the shared page
        separator={intl.formatMessage({
          defaultMessage: ' - sliding doors with unforgetable style',
          id: 'Dh6zcM',
        })} // (string, default=" "): Separates title from the url
      >
        <WhatsappIcon {...shareButtonsCommonProps.iconProps} />
      </WhatsappShareButton>
      {productImage && (
        <PinterestShareButton
          url={productUrl}
          media={productImage}
          description={intl.formatMessage({
            defaultMessage:
              'Sliding doors with unforgetable style, best qaulity and wide choice of sizes and colors  - find your #RENOdoors',
            id: 'KztajJ',
          })} // (string, default=" "): Separates title from the url
        >
          <PinterestIcon {...shareButtonsCommonProps.iconProps} />
        </PinterestShareButton>
      )}
    </S.ShareIconsWrapper>
  );
}
